import packageJson from '../../../../package.json';

const appVersion = packageJson.version;

export const checkAppVersion = async () => {
    const res = await fetch(`/version.json?t=${Date.now()}`);

    if (res.ok) {
        const { version } = await res.json();

        return version.trim() !== appVersion.trim();
    }

    return false;
};
